<script lang="ts" setup>
import { onMounted, nextTick, useTemplateRef, watch } from 'vue';

import FloatNavigator from '@/home/components/FloatNavigator.vue';
import FloatNavigatorItem from '@/home/components/FloatNavigatorItem.vue';

import WelfareDonate from './components/WelfareDonate.vue';
import Partner from './components/Partner.vue';
import ProjectDonate from './components/ProjectDonate.vue';

const navigatorRef = useTemplateRef('navigatorEl');

const props = defineProps({
  navigator: {
    type: String,
    default: '',
  },
});

const navigatorMap = {
  financial: 0,
  project: 1,
  partner: 2,
};

const gotoNavigator = async () => {
  await nextTick();
  const index = navigatorMap[props.navigator as keyof typeof navigatorMap];
  if (index !== undefined) {
    navigatorRef.value?.goto(index);
  }
};

watch(() => props.navigator, (newVal) => {
  if (newVal) {
    gotoNavigator();
  }
});

onMounted(() => {
  gotoNavigator();
});
</script>

<template>
  <main class="page-cooperation">
    <section class="cooperation-title bg-cover bg-center bg-no-repeat <md:min-h-240 <md:flex <md:items-center <md:py-40">
      <div class="cooperation-title__container mx-auto w-[1360px] pb-0 pt-125px <2xl:w-1200px <2xl:pb-80px <xl:w-full <xl:px-24 <md:py-0 <sm:px-16">
        <h1 class="m-0 font-medium">
          <span class="<md:block">{{ $t('cooperation.title') }}</span>
          <small class="align-middle font-medium <md:mt-8 <md:block <md:text-16">{{ $t('cooperation.titleSmall') }}</small>
        </h1>
        <p class="m-0 <md:mt-16">
          {{ $t('cooperation.titleDescription') }}
        </p>
      </div>
    </section>

    <FloatNavigator bar-class="w-[1360px] mx-auto <2xl:w-1200px <xl:w-full <xl:px-24 <sm:px-16" ref="navigatorEl">
      <FloatNavigatorItem :label="$t('cooperation.navigator1')">
        <WelfareDonate />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('cooperation.navigator2')">
        <ProjectDonate />
      </FloatNavigatorItem>
      <FloatNavigatorItem :label="$t('cooperation.navigator3')">
        <Partner />
      </FloatNavigatorItem>
    </FloatNavigator>
  </main>
</template>

<style lang="scss" scoped>
.page-cooperation {
  padding-bottom: 80px;
  color: #2d2d2d;

  .cooperation-title {
    min-height: 400px;
    background-color: #f7f9f9;
    background-image: url(@/home/assets/cooperation/title-bg.jpg);

    .cooperation-title__container {
      h1 {
        font-size: 50px;

        span {
          line-height: 70px;
        }

        small {
          margin-left: 24px;
          font-size: 24px;
          line-height: 36px;
        }
      }

      p {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
      }

      @media (max-width: 767.9px) {
        h1 {
          font-size: 32px;

          span {
            line-height: 44px;
          }

          small {
            margin-left: 12px;
            font-size: 16px;
            line-height: 28px;
          }
        }
      }
    }

    @media (max-width: 767.9px) {
      min-height: 0;
      padding-bottom: 64px;
      text-align: center;
      background: linear-gradient(160deg, #eaf2ff, #f5f7fa);
    }
  }
}
</style>
